import React from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { messages } from './messages.tsx';

export const IssueLeftIcon = ({
	iconUrl,
	issueTypeName,
}: {
	iconUrl?: string;
	issueTypeName?: string;
}): React.JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<img
			src={iconUrl}
			alt={
				!issueTypeName && fg('deliveroo_compal_a11y_fixes')
					? ''
					: formatMessage(
							// eslint-disable-next-line no-nested-ternary
							fg('deliveroo_compal_a11y_fixes')
								? messages.workTypeIconAltText
								: fg('jira-issue-terminology-refresh-m3')
									? messages.issueIconAltTextIssueTermRefresh
									: messages.issueIconAltText,
							{
								issueTypeName,
							},
						)
			}
			height="16"
		/>
	);
};
